import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/splashPage/avatars/missingPerson.webp'

export const MissingPersonImage: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'Missing person'} />
)
